import React, { useContext, useState } from "react";
import { SearchContext } from "../SearchContext";
import * as imagenes from "../imagenes";

const productosData = [
  // CARTUCHOS
  { id: 1, nombre: "Cartucho HT60", categoria: "Cartuchos", imagenKey: "crtHt60" },
  { id: 2, nombre: "Cartucho HX25", categoria: "Cartuchos", imagenKey: "crtHx25" },
  { id: 18, nombre: "Cartucho HX35W", categoria: "Cartuchos", imagenKey: "crtHx35w" },
  { id: 19, nombre: "Cartucho HX55", categoria: "Cartuchos", imagenKey: "crtHx55"},
  { id: 20, nombre: "Cartucho K03-4", categoria: "Cartuchos", imagenKey: "crtK03" },
  { id: 21, nombre: "Cartucho K16", categoria: "Cartuchos", imagenKey: "crtK16" },
  { id: 22, nombre: "Cartucho K24", categoria: "Cartuchos", imagenKey: "crtK24" },
  { id: 23, nombre: "Cartucho K27", categoria: "Cartuchos", imagenKey: "crtK27" },
  { id: 24, nombre: "Cartucho S300V110", categoria: "Cartuchos", imagenKey: "crtS300v1" },
  { id: 25, nombre: "Cartucho T04B58", categoria: "Cartuchos", imagenKey: "crtT04B58" },

  // PROPELAS
  { id: 3, nombre: "Propela MHe561", categoria: "Propelas", imagenKey: "propMHe561" },
  { id: 9, nombre: "Propela HE561V", categoria: "Propelas", imagenKey: "propHe561V" },

  // TURBOS
  { id: 4, nombre: "Turbo HE451VE", categoria: "Turbo", imagenKey: "turboHe451vE" },
  { id: 8, nombre: "Turbo HE551V", categoria: "Turbo", imagenKey: "turboHe551V" },
  { id: 13, nombre: "Turbo HE561VE", categoria: "Turbo", imagenKey: "turboHe561Ve" },
  { id: 14, nombre: "Turbo HT3B", categoria: "Turbo", imagenKey: "turboHt3b" },
  { id: 30, nombre: "Turbo HX55", categoria: "Turbo", imagenKey: "turboHx55" },
  { id: 31, nombre: "Turbo HX55 DD15", categoria: "Turbo", imagenKey: "turboHx55Dd15" },
  { id: 32, nombre: "Turbo HX55W", categoria: "Turbo", imagenKey: "turboHx55w" },
  { id: 33, nombre: "Turbo K24", categoria: "Turbo", imagenKey: "turboK24" },
  { id: 34, nombre: "Turbo N14", categoria: "Turbo", imagenKey: "turboN14" },
  { id: 35, nombre: "Turbo T04B58", categoria: "Turbo", imagenKey: "turboT04b58" },

  // KIT DE SERVICIO
  { id: 5, nombre: "kit de servicio HE351", categoria: "Kit de Servicio", imagenKey: "kit351" },
  { id: 10, nombre: "kit de servicio HE431", categoria: "Kit de Servicio", imagenKey: "kit431" },
  { id: 15, nombre: "kit de servicio HE561VE", categoria: "Kit de Servicio", imagenKey: "kit561ve" },

  // FLECHAS
  { id: 6, nombre: "Flecha HE351V", categoria: "Flechas", imagenKey: "flHe351V" },
  { id: 11, nombre: "Flecha HE431V", categoria: "Flechas", imagenKey: "flHe431V" },
  { id: 16, nombre: "Flecha HE561V", categoria: "Flechas", imagenKey: "flHe561V" },
  { id: 26, nombre: "Flecha HT3B", categoria: "Flechas", imagenKey: "flHT3B" },
  { id: 27, nombre: "Flecha HX55", categoria: "Flechas", imagenKey: "flHx55" },
  { id: 28, nombre: "Flecha HX55 ISX", categoria: "Flechas", imagenKey: "flHx55Isx" },

  // GEOMETRÍAS
  { id: 7, nombre: "Geometria Completa HE551 HE561VE HE531VE HE500VE", categoria: "Geometrías", imagenKey: "geoCHe551" },
  { id: 12, nombre: "Geometria Reforzada HE551V HE561VE HE531VE HE500VE", categoria: "Geometrías", imagenKey: "geoRHe551" },
  { id: 17, nombre: "Geometria sencilla HE561VE HE531VE HE500VE", categoria: "Geometrías", imagenKey: "geoSHe551" },
  { id: 29, nombre: "Geometria variable S300V", categoria: "Geometrías", imagenKey: "geoVS300v" },

  // MODULOS
  { id: 36, nombre: "Modulo VGT HE561", categoria: "Modulos", imagenKey: "Vgthe561" },
];

const categorias = [
  "Todos",
  "Turbo",
  "Kit de Servicio",
  "Propelas",
  "Geometrías",
  "Flechas",
  "Cartuchos",
  "Modulos",
];

// Asocia la imagen automáticamente usando la clave
const productos = productosData.map(p => ({
  ...p,
  imagen: imagenes[p.imagenKey]
}));

export default function ProductPage() {
  const { search, setSearch } = useContext(SearchContext); // <-- agrega setSearch aquí
  const [categoria, setCategoria] = useState("Todos");

  const productosFiltrados = productos.filter((p) => {
    const matchCategoria =
      categoria === "Todos" ? true : p.categoria === categoria;
    const matchSearch =
      p.nombre.toLowerCase().includes(search.toLowerCase());
    return matchCategoria && matchSearch;
  });

  return (
    <div className="relative flex min-h-screen w-full flex-col bg-background-dark group/design-root overflow-x-hidden text-white">
      <div className="flex h-full grow flex-col">
        {/* Main */}
        <main className="w-full">
          <div className="py-10 px-10">
            {/* Search and Filters */}
            <div className="flex flex-col md:flex-row items-center gap-4 mb-8 bg-[#1c2327] p-4 rounded-lg">
              <div className="relative flex-grow">
                <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                  <span className="material-symbols-outlined text-[#9db0b9]">search</span>
                </div>
                <input
                  className="form-input w-full rounded-full text-white bg-[#283339] border-none pl-10 pr-4 placeholder:text-[#9db0b9] focus:ring-primary"
                  id="search"
                  placeholder="Buscar turbo, kit, flecha..."
                  type="text"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
              <div className="flex-shrink-0 flex flex-wrap justify-center gap-3">
                {categorias.map((cat) => (
                  <button
                    key={cat}
                    className={`flex min-w-[84px] max-w-[480px] cursor-pointer items-center justify-center overflow-hidden rounded-full h-10 px-4 text-sm font-bold leading-normal tracking-[0.015em] border transition-all duration-300 ${
                      categoria === cat
                        ? "bg-primary text-white border-primary"
                        : "bg-[#283339] text-white border-transparent hover:border-primary"
                    }`}
                    onClick={() => setCategoria(cat)}
                  >
                    <span className="truncate">{cat}</span>
                  </button>
                ))}
              </div>
            </div>
            {/* Products Grid */}
            <section className="w-full">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {productosFiltrados.length === 0 && (
                  <div className="col-span-3 text-center text-[#9db0b9] py-10">
                    No se encontraron productos.
                  </div>
                )}
                {productosFiltrados.map((producto) => (
                  <div
                    key={producto.id}
                    className="relative flex flex-col gap-4 rounded-lg bg-[#1c2327] shadow-[0_0_4px_rgba(0,0,0,0.1)] border-2 border-transparent hover:border-primary transition-all duration-300"
                  >
                    <div className="w-full bg-center bg-no-repeat aspect-square bg-cover rounded-t-lg flex items-center justify-center">
                      <img
                        src={producto.imagen}
                        alt={producto.nombre}
                        className="object-contain w-full h-full rounded-t-lg"
                      />
                    </div>
                    <div className="flex flex-col flex-1 justify-between p-4 pt-0">
                      <div>
                        <h4 className="text-white text-lg font-medium leading-normal">
                          {producto.nombre}
                        </h4>
                        <p className="text-[#9db0b9] text-sm">{producto.marca}</p>
                        <p className="text-primary text-xl font-bold mt-2">
                          {producto.precio}
                        </p>
                      </div>
                      <a
                        href={`https://wa.me/523346583496?text=${encodeURIComponent(
                          "Hola, quiero información sobre " + producto.nombre
                        )}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={`Comprar ${producto.nombre} por WhatsApp`}
                        className="flex items-center justify-center w-full px-4 h-10 bg-primary text-white text-sm font-bold rounded-lg mt-4 transition-all duration-300 hover:opacity-90"
                      >
                        <span className="material-symbols-outlined mr-2">shopping_cart</span>
                        Comprar Ahora
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </section>
          </div>
        </main>
      </div>
    </div>
  );
}